export default __webpack_public_path__ + "static/media/landing2.a27b6163.png";